import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import BannerComp from "../components/BannerComp";
import ContactForm from "../components/ContactForm";
import Seo from "../components/Seo";
import contactInfo from "../data/contactInfo";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";
import styles from "./Contact.module.css";

const seo = {
  title: "Contact MITSI | MIT4Doctors",
  description:
    "We are here to help! If you want to improve your practice with new tech, our team can help. We offer custom solutions and expert support.",
  schema: [
    createWebPageSchema({
      path: "/contact-us",
      title: "Contact MITSI",
      description:
        "We are here to help! If you want to improve your practice with new tech, our team can help. We offer custom solutions and expert support.",
    }),
    createBreadcrumbSchema("/contact-us", "Contact MITSI"),
  ],
};

export default function Contact() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/contact-us"
        schema={seo.schema}
      />
      <BannerComp
        heading="Contact MITSI"
        paragraph="We are here to help! If you want to improve your practice with new tech, our team can help. We offer custom solutions and expert support."
        centered
        BannerBgImg="/img/banners/contact_hero.webp"
      />

      <section className={styles.section}>
        <div className={`container ${styles.shell}`}>
          <div className={styles.infoColumn}>
            <h2>Connect with Our Team</h2>
            <p>
              At MITSI, we’re here to assist you with all your healthcare
              technology needs. For questions, to schedule a consultation, or to
              learn about our services, please contact us by phone, email, or
              text.
            </p>
            <h3>We're ready to help!</h3>
            <p>
              Revolutionize care, one conversation at a time. Connect with us
              today! A simple message will start your journey to better patient
              outcomes.
            </p>

            <div className={styles.infoItem}>
              <span className={styles.infoIcon} aria-hidden="true">
                <FiPhone />
              </span>
              <a href={contactInfo.phoneHref}>{contactInfo.phone}</a>
            </div>

            <div className={styles.infoItem}>
              <span className={styles.infoIcon} aria-hidden="true">
                <FiMail />
              </span>
              <a href={contactInfo.emailHref}>{contactInfo.email}</a>
            </div>

            <div className={styles.infoItem}>
              <span className={styles.infoIcon} aria-hidden="true">
                <FiMapPin />
              </span>
              <a
                href={contactInfo.address.mapHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                {contactInfo.address.full}
              </a>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>
    </>
  );
}
